import CustomIcon from '@components/utils/CustomIcon';
import Typography from '@components/Typography';

import { BadgeContainer, TextContainer } from './styled';

const Badge = ({ icon, text }: { icon: any; text: string }) => {
  return (
    <BadgeContainer>
      <CustomIcon icon={icon} fontSize={16} paletteColor='NL800' />
      <TextContainer>
        <Typography variant='caption3' weight='Regular' color='NL800'>
          {text}
        </Typography>
      </TextContainer>
    </BadgeContainer>
  );
};

export default Badge;
